import Api from 'services/Api';

const delet = (id, reducer, url, callback) => {
	return (dispatch) => {
		dispatch({
			type: reducer.FETCHING_DELETE,
			payload: {
				id
			}
		});
		Api.delete(
			{},
			url + '/' + id,
			(error, data) => {
				if (error) {
					return dispatch({
						type: reducer.ERROR_DELETE,
						payload: {
							message: data,
							id
						}
					});
				}

				dispatch({
					type: reducer.LOADED_DELETE,
					payload: {
						message: data,
						id
					}
				});


				dispatch({
					type: reducer.UPDATE_COLLECTION,
					payload: {
						id,
						type: 'delete'
					}
				});
			}
		);
	};
};
export default delet;
